// Libs
import { createSelector } from 'reselect'
import _map from 'lodash/map'
import _filter from 'lodash/filter'
import _indexOf from 'lodash/indexOf'

// Selectors
import fieldsOfSelectedFarmAndSeason$ from 'hfty-assets/src/selectors/fieldsOfSelectedFarmAndSeason'
import ancestorsIndex$ from 'fc-assets/src/selectors/ancestorsIndex'
import jobs$ from './jobs'

// Constants
import { PROP_ASSET_ID } from 'fc-model-assets'

import {
  PROP_FIELD,
} from 'fc-model-sampling-jobs'

// Utils
import emptyArrayOr from 'fc-utils/emptyArrayOr'

// Exports
export default createSelector(
  [
    fieldsOfSelectedFarmAndSeason$,
    jobs$,
    ancestorsIndex$,
  ],
  (fields, jobs, ancestors) => {
    // Map filtered fields to a list of their ids
    const fieldIds = _map(fields, PROP_ASSET_ID)

    // Filter jobs by checking against the list of field ids
    return emptyArrayOr(_filter(jobs, function (job) {
      return _indexOf(fieldIds, job[PROP_FIELD]) >= 0
    }))
  })
